export default __webpack_public_path__ + "static/media/pokezon_recording.b3f76923.mp4";